import Link from "next/link";
import { brand } from "@config/brand";
import { BrandLogo } from "@/components/BrandLogo";
import { MobileNav } from "@/components/MobileNav";

const links = [
  { href: "/pricing", label: "Pricing" },
  { href: "/service-areas", label: "Check availability" },
  { href: "/how-it-works", label: "How it works" },
  { href: "/faq", label: "FAQ" },
  { href: "/quote", label: "Get a quote" },
  { href: "/login", label: "Login" },
];

export function SiteHeader() {
  return (
    <header className="relative z-50 border-b border-[var(--line)] bg-[var(--surface)]/90 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-4">
        <BrandLogo />
        <nav className="hidden items-center gap-5 text-sm text-[var(--muted)] md:flex">
          {links.map((l) => (
            <Link key={l.href} href={l.href} className="hover:text-[var(--ink)]">
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link
            href="/quote"
            className="hidden rounded-md bg-[var(--accent)] px-3 py-2 text-sm font-medium text-white md:inline-flex"
          >
            Instant quote
          </Link>
          <MobileNav />
        </div>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="mt-auto border-t border-[var(--line)] bg-[var(--surface)]">
      <div className="mx-auto max-w-6xl px-4 pt-8 pb-3">
        <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
          <BrandLogo size="sm" />
          <div className="flex flex-wrap gap-4 text-sm text-[var(--muted)]">
            <Link href="/pricing">Pricing</Link>
            <Link href="/quote">Get a quote</Link>
            <Link href="/terms">Terms</Link>
            <Link href="/privacy">Privacy &amp; SMS Policy</Link>
            <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>
          </div>
        </div>
      </div>
      <div className="border-t border-[var(--line)]">
        <p className="mx-auto max-w-6xl px-4 py-4 text-center text-xs text-[var(--muted)] md:text-left">
          © 2026 {brand.legalEntityName}
        </p>
      </div>
    </footer>
  );
}
